import { faShareAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import GlobalStoreContext from "../../context/GlobalStoreContext";
import { CalendarEvent } from "../../models/CalendarEvent";
import { Delivery } from "../../models/Delivery";
import ShareProjectItemModal from "../UI/ShareProjectItem/shareProjectItemModal";

interface Props {
    calendarEvent: CalendarEvent;
    delivery: Delivery;
    actions?: React.ReactNode;
}

const DamnHeader: React.FC<Props> = (props) => {
    const context = React.useContext(GlobalStoreContext);

    const [showShareModal, setShowShareModal] = useState(false);

    return (
        <header className="bg-white/80 backdrop-blur-xl border-b border-gray-200/50 sticky top-0 z-50 shadow-lg">
            <div className="px-5 py-4 flex items-center justify-between">
                <div className="flex flex-col flex-1 min-w-0">
                    <h1 className="text-xl font-bold text-plot-orange tracking-tight truncate">
                        {props.calendarEvent.name}
                    </h1>
                    <p className="text-xs font-bold text-gray-900 mt-1 uppercase tracking-wider">
                        {context.currentProjectInfo.project_name}
                    </p>
                </div>
                <div className="flex items-center gap-2">
                    {props.actions}
                    <button
                        onClick={() => setShowShareModal(true)}
                        className="p-2.5 cursor-pointer hover:bg-plot-orange/10 rounded-xl transition-all duration-200 hover:scale-105"
                        aria-label="Share"
                    >
                        <FontAwesomeIcon icon={faShareAlt} className=" text-gray-700 hover:text-plot-orange" />
                    </button>
                </div>
            </div>
            <ShareProjectItemModal
                showModal={showShareModal}
                hideModal={() => setShowShareModal(false)}
                shareType="delivery"
                projectToken={context.currentProjectInfo.unique_token}
                calendarEvent={props.calendarEvent}
                delivery={props.delivery}
            />
        </header>
    );
};

export default DamnHeader;
